import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  BulkActionsComponent,
  BulkActionCreateOrEditComponent,
  BulkActionViewComponent
} from '../upgrade/bulk-actions.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { forceOnlineGuard } from '@fry-it/risr-core';

export const bulkActionsRoutes: Routes = [
  {
    path: 'bulk-actions',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, forceOnlineGuard],
    children: [
      {
        path: '',
        component: BulkActionsComponent,
        data: {
          state: 'epf.bulk-actions.index'
        }
      },
      {
        path: 'new',
        component: BulkActionCreateOrEditComponent,
        data: {
          state: 'epf.bulk-actions.new'
        }
      },
      {
        path: 'edit/:bulkActionId',
        component: BulkActionCreateOrEditComponent,
        data: {
          state: 'epf.bulk-actions.edit'
        }
      },
      {
        path: 'view/:bulkActionId',
        component: BulkActionViewComponent,
        data: {
          state: 'epf.bulk-actions.view'
        }
      }
    ]
  }
];
